import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mza-label-field',
  templateUrl: './label-field.component.html',
  styleUrls: ['./label-field.component.css']
})
export class LabelFieldComponent implements OnInit {

  @Input() label: string;
  @Input() value: string;

  constructor() { }

  ngOnInit() {
  }

}
